export const DEFAULT_FLUID_TEXT_ZOOM = 100;
export const MIN_FLUID_TEXT_ZOOM = 75;
export const MAX_FLUID_TEXT_ZOOM = 150;

export function normalizeFluidTextZoom(value: unknown): number {
    if (typeof value !== "number" || !Number.isFinite(value)) {
        return DEFAULT_FLUID_TEXT_ZOOM;
    }
    return Math.min(MAX_FLUID_TEXT_ZOOM, Math.max(MIN_FLUID_TEXT_ZOOM, Math.round(value)));
}
